﻿import _ from 'lodash';
import $ from 'jquery';
window.JQuery = $;
window.jQuery = $;
jQuery = $;
window.$ = $;

var coreUi = require('@coreui/coreui/dist/js/coreui');
var coreUiUtilities = require('@coreui/coreui/dist/js/coreui-utilities');
var bootStrap = require('bootstrap/dist/js/bootstrap.bundle');

import validate from 'jquery-validation';
import validateunobtrusive from 'jquery-validation-unobtrusive';
var cookies = require("./js/cookies.js");
require('easy-autocomplete/dist/jquery.easy-autocomplete');
require("./js/textCounter");

//require('webpack-jquery-ui');

//function component() {
//    var element = document.createElement('div');
//    element.innerHTML = _.join(['Hello', 'webpack'], ' ');
//    return element;
//}
//document.body.appendChild(component());
//$('#fillthiswithjquery').html('Filled by Jquery!');

